export const LOGO = './assets/logos/ambienta_logo.png'
